<template>
  <div class="dynamic-tags">
    <el-tag
      :key="index"
      v-for="(tag, index) in value"
      :closable="true"
      :close-transition="false"
      @close="handleClose(tag)"
    >
      {{ tag }}
    </el-tag>
    <el-input
      v-model="inputValue"
      :disabled="!inputVisible"
      ref="saveTagInput"
      size="mini"
      class="new-tag-input"
      :placeholder="newTagLabel"
      @keyup.enter.native="handleInputConfirm"
      @blur="handleInputConfirm"
    >
    </el-input>
  </div>
</template>

<script>
export default {
  name: 'DynamicTags',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    newTagLabel: {
      type: String,
      default: '',
    },
    max: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    tags() {
      return this.value || [];
    },
    inputVisible() {
      return this.max === 0 || this.tags.length < this.max;
    },
  },
  data() {
    return {
      inputValue: '',
    };
  },
  methods: {
    handleClose(tag) {
      const tags = this.tags.slice(0);
      tags.splice(tags.indexOf(tag), 1);
      this.$emit('input', tags);
    },
    showInput() {
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      if (this.inputValue) {
        const tags = this.tags.slice(0);
        tags.push(this.inputValue);
        this.$emit('input', tags);
      }
      this.inputValue = '';
    },
  },
};
</script>
